import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { onMounted, ref } from "vue";
import CodeEditor from "./CodeEditor.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Wrapper',
    props: {
        value: {},
        eventBus: {},
        contextType: {},
        className: {},
        onGetValue: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const monacoRef = ref();
        onMounted(() => {
            props.eventBus.on("emitEvent", () => {
                monacoRef.value.getValue();
            });
        });
        return (_ctx, _cache) => {
            return (_ctx.contextType)
                ? (_openBlock(), _createBlock(CodeEditor, {
                    key: 0,
                    value: _ctx.value,
                    className: _ctx.className,
                    contextType: _ctx.contextType,
                    onTransmitValue: _cache[0] || (_cache[0] = (value) => _ctx.onGetValue(value)),
                    ref_key: "monacoRef",
                    ref: monacoRef
                }, null, 8 /* PROPS */, ["value", "className", "contextType"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
